// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReportNftModal_footer__3OQ0k","label":"ReportNftModal_label__3pJwH"};